// extracted by mini-css-extract-plugin
export var logo = "logo-module--logo--2PX9r";
export var logoText = "logo-module--logo-text--1sxgC";